<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <div class="content_left">
          <el-card>
            <div class="sideBar">
              <div class="head_title">{{ titleData.title }}</div>
              <div class="divide_line"></div>
              <div v-for="(item,index) in titleData.children" :key="index" class="head_title_ch"
                   :class="index == activeIndex?'navActive':'nav'" @click="subTitleClick(index,item)">{{ item.title }}
              </div>


            </div>
          </el-card>
        </div>
        <div class="content_right">
          <el-card>
            <div slot="header" class="text_title">
              <span>{{ titleDataChild[activeIndex].title }}</span>
            </div>
            <div ref="month" style="width: 100%;height: 150px"></div>

            <!-- Advanced Search Area -->
            <div class="advanced-search">
<!--              <h3>{{ $t('navigation.advancedSearch') || 'ADVANCED SEARCH' }}</h3>-->
              <div class="search-form">
                <el-input
                  v-model="queryParams.title"
                  :placeholder="$t('home.placeholder') || 'Enter keyword'"
                  class="search-input">
                </el-input>
                <el-date-picker
                  v-model="queryParams.startTime"
                  type="date"
                  :placeholder="$t('home.startDate') || 'Start date'"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="date-picker">
                </el-date-picker>
                <el-date-picker
                  v-model="queryParams.endTime"
                  type="date"
                  :placeholder="$t('home.endDate') || 'End date'"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  class="date-picker">
                </el-date-picker>
                <el-button type="primary" @click="handleSearch" class="search-button">
                  {{ $t('home.search') || 'SEARCH' }}
                </el-button>
              </div>
            </div>

            <div class="news-list">
              <div v-for="(item,index) in contentList" :key="index" class="news-item" @click="openDetail(item)">
                <div class="news-image">
                  <img v-if="item.Img" :src="$urlFile+item.Img" alt="News cover" />
                  <div v-else class="placeholder-image">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </div>
                <div class="news-content">
                  <h3 class="news-title">
                    <span class="text_type" v-if="item.className">[{{ item.className }}]</span>
                    {{ item.title }}
                  </h3>
                  <p class="news-summary">{{ item.zhaiYao || $t('home.noSummary') }}</p>
                  <div class="news-footer">
                    <span class="news-time">{{ item.time }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="total==0" class="no-data">{{ $t('home.noData') }}</div>
            <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth>800&&$i18n.locale == 'zh'">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryParams.size"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </el-row>
            <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth>800&&$i18n.locale == 'en'">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryParams.size"
                layout="sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </el-row>
            <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth<=800&&$i18n.locale == 'zh'">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryParams.size"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </el-row>
            <el-row style="text-align: center;margin-top: 10px" v-if="windowWidth<=800&&$i18n.locale == 'en'">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.index"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryParams.size"
                layout="sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </el-row>
          </el-card>

        </div>
      </div>
    </div>
    <!-- <shareDialog ref="shareDialog"></shareDialog> -->
  </div>
</template>

<script>
// import shareDialog from './subcomponents/shareDialog'
import {getContentList} from "@/api/navigation"
import cookie from "js-cookie";
import {monthly} from "../../api/navigation";
import * as echarts from "echarts";

export default {
  name: 'aboutUs',
  components: {
    // shareDialog
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      imageUrl: require('@/components/aboutUs/imgs/facebook.png'),
      imageUrl2: require('@/components/aboutUs/imgs/Twitter.png'),
      // isThirdLevel:this.$route.query.isThirdLevel,
      pid: this.$route.query.pid,
      id: this.$route.query.id,
      total: 0,//总数
      activeIndex: 0,
      queryParams: {
        index: 1,
        size: 10,
        keyword: '',
        startTime: '',
        endTime: ''
      },
      titleTree: JSON.parse(sessionStorage.getItem('titleTree')),
      titleData: {},//标题内容
      titleDataChild: [{title: ""}],
      contentList: [],//内容展示列表,
      flag: false,
      monthlyList: [],
    }
  },
  created() {
    this.$watch('$route', () => {
      // this.titleTree =
      // this.isThirdLevel = this.
      // this.pid = this.
      // this.id = this.$route.query.id
      window.location.href = window.location.href
      // this.init(); // 监听路由变化，重新加载数据
    });
  },
  mounted() {
    // this.titleTree =
    // this.isThirdLevel = this.
    // this.pid = this.
    // this.id = this.$route.query.id
    this.init()
  },
  methods: {
    init() {
      var that = this;
      this.flag = false //是否为二级标题
      this.titleTree.children.forEach((item, index) => {
        if (item.data.id == this.id) {
          this.flag = true
        }
      });
      if (this.flag) {
        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.id) {
            this.titleData = item
            this.titleDataChild = this.titleData.children
            this.queryParams.classId = item.children[0].data.id
            this.activeIndex = 0
          }
        });
        this.getData()
      } else {
        this.titleTree.children.forEach((item, index) => {
          if (item.data.id == this.pid) {
            this.titleData = item
            this.titleDataChild = this.titleData.children

            this.queryParams.classId = this.id
            item.children.forEach((item2, index2) => {
              if (item2.data.id == this.id) {
                this.activeIndex = index2

              }
            })
          } else {
            if (item.children != null) {
              item.children.forEach((it, ind) => {
                if (it.data.id == that.pid) {
                  that.titleData = it
                  that.titleDataChild = it.children
                  that.queryParams.classId = that.id
                  it.children.forEach((it2, ind2) => {
                    if (it2.data.id == that.id) {
                      that.activeIndex = ind2
                    }
                  })
                }
              })
            }
          }
        });
        this.getData()
      }
    },
    getData() {
      if (this.$i18n.locale == 'zh') {
        this.queryParams.lang = "1"
      } else {
        this.queryParams.lang = "2"
      }
      getContentList(this.queryParams).then(res => {
        this.contentList = res.data
        this.total = res.count
      })
      monthly(this.queryParams).then(res => {
        this.monthlyList = res.data
        // 准备 echarts 数据
        let months = [];
        let counts = [];

        if (res.data.length > 0) {
           months = res.data.map(item => item.month);
           counts = res.data.map(item => item.count);
        }

        let myChart = echarts.init(this.$refs.month)
        // 配置 echarts
        const option = {
          grid: {
            top: '5%',
            left: '1%',
            right: '4%',
            bottom: '8%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: months
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: counts,
            type: 'bar'
          }]
        };

        // 渲染图表
        myChart.setOption(option);

        // 添加点击事件
        myChart.on('click', (params) => {
          // 获取点击的月份
          const clickedMonth = params.name;

          // 设置查询参数
          this.queryParams.index = 1;

          // 从月份字符串中提取年和月
          const [year, month] = clickedMonth.split('-');

          // 设置开始时间为当月第一天
          this.queryParams.startTime = `${year}-${month}-01`;

          // 计算当月最后一天
          const lastDay = new Date(year, parseInt(month), 0).getDate();
          this.queryParams.endTime = `${year}-${month}-${lastDay}`;

          // 执行搜索
          this.handleSearch();
        });
      })

    },
    shareClick() {
      this.$refs.shareDialog.open('Repost to Facebook', {})

    },
    subTitleClick(index, item) {

      /*if(item.data.cHtml=='2'){

      }else{
        this.activeIndex = index
        this.queryParams.classId = this.titleData.children[index].data.id
        this.queryParams.index = 1
        this.queryParams.size = 10
        this.getData()
      }*/
     if(item.data.columnPid===7&&this.$i18n.locale == 'zh'||item.data.columnPid===82&&this.$i18n.locale == 'en'){
      if(index==0||index==1){
        this.$router.push({
            path: '/cardNavigation',
            query: {
              pid: item.data.columnPid,
              id: item.data.id,
              // isThirdLevel: true,
            }
          })
      }else{
        this.activeIndex = index
        this.queryParams.classId = this.titleData.children[index].data.id
        this.queryParams.index = 1
        this.queryParams.size = 10
        this.getData()
      }
     }else{
      this.activeIndex = index
      this.queryParams.classId = this.titleData.children[index].data.id
      this.queryParams.index = 1
      this.queryParams.size = 10
      this.getData()
     }


    },
    openDetail(item) {
      if (item.url != "") {
        window.open(item.url)
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            pid: this.flag ? this.id : this.pid,
            id: item.classId,
            detailId: item.id,
          }
        })
      }
      // console.log("item",item)

    },
    /**页条数变化 */
    handleSizeChange(val) {
      this.queryParams.size = val
      this.queryParams.index = 1
      //   this.pageList()
      this.getData()
    },
    /**当前页变化 */
    handleCurrentChange(val) {
      this.queryParams.index = val
      //   this.pageList()

      this.getData()
    },
    handleSearch() {
      this.queryParams.index = 1
      this.getData()
    },
  }
}
</script>

<style lang="less" scoped>

// 大于800px
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;

    .containerbody {
      width: 100%;
      min-height: 55.5vh;
      // max-width:1000px ;
      background-color: rgb(249, 249, 249);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0;

      .content {
        width: 80%;
        margin: 0 auto;

        .content_left {
          width: 16%;
          float: left;

          .sideBar {
            text-align: left;
            width: 100%;

            .head_title {
              padding: 0 0 20px 0;
              color: rgba(51, 51, 51, 1);
              font-family: SourceHanSansCN-Bold;
              font-weight: 700;
              font-size: 18px;
              font-weight: bold;
            }

            .sub_title {
              padding: 4px 0;
              color: rgba(51, 51, 51, 1);
              font-family: SourceHanSansCN-Regular;
              font-size: 12px;

            }

            .divide_line {
              width: 90%;
              height: 1.5px;
              margin: 4px 0;
              background-color: #2D52D0;
            }

            .nav {
              overflow-wrap: break-word;
              color: rgba(110, 110, 115, 1);
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              white-space: nowrap;
              line-height: 24px;
              margin: 15px 0 10px 0;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .nav:hover {
              overflow-wrap: break-word;
              color: #2D52D0;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              line-height: 24px;
              margin: 15px 0 10px 0;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .navActive {
            overflow-wrap: break-word;
            color: #2D52D0;
            font-size: 12px;
            font-family: SourceHanSansCN-Regular;
            font-weight: normal;
            white-space: nowrap;
            line-height: 24px;
            margin: 15px 0 10px 0;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .content_right {
          width: 82%;
          float: right;
          // margin-left: 3%;
          .text_title {
            width: 100%;
            // padding: 32px 0;
            text-align: left;
            font-family: SourceHanSansCN-Bold;
            font-weight: 700;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            // font-weight: bold;
          }

          .news-list {
            margin-bottom: 20px;
          }

          .news-item {
            display: flex;
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #eaeaea;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-3px);
              box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
            }

            &:last-child {
              margin-bottom: 0;
            }
          }

          .news-image {
            flex: 0 0 180px;
            height: 120px;
            margin-right: 20px;
            overflow: hidden;
            border-radius: 4px;
            background-color: #f5f7fa;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }

            .placeholder-image {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              color: #c0c4cc;

              i {
                font-size: 40px;
              }
            }
          }

          .news-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
          }

          .news-title {
            margin: 0 0 10px;
            font-size: 18px;
            font-weight: 600;
            color: #333;
            line-height: 1.4;
            text-align: left;

            .text_type {
              color: #3a8ee6;
              margin-right: 5px;
            }
          }

          .news-summary {
            margin: 0 0 15px;
            font-size: 14px;
            color: #666;
            line-height: 1.6;
            text-align: left;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .news-footer {
            display: flex;
            justify-content: flex-start;
          }

          .news-time {
            font-size: 13px;
            color: #909399;
          }

          .no-data {
            padding: 30px 0;
            text-align: center;
            color: #CCCCCC;
            font-size: 14px;
          }
        }
      }
    }
  }
}

// 小于800px
@media only screen and (max-width: 800px) {
  .sideBar {
    display: flex;
    //width: 100%;
    overflow: auto;
  }
  .containerbody {
    min-height: 60vh;
  }
  .head_title{
    overflow-wrap: break-word;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular;
    //font-weight: normal;
    white-space: nowrap;
    line-height: 24px;
    margin: 15px 5px 10px 5px;
    cursor: pointer;
    //overflow: hidden;
    //text-overflow: ellipsis;
  }
  .head_title_ch{
    overflow-wrap: break-word;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    font-weight: normal;
    white-space: nowrap;
    line-height: 24px;
    margin: 15px 5px 10px 10px;
    cursor: pointer;
    //overflow: hidden;
    text-overflow: ellipsis;
  }
  .navActive {
    //overflow-wrap: break-word;
    color: #2D52D0;
    //font-size: 14px;
    //font-family: SourceHanSansCN-Regular;
    //font-weight: normal;
    //white-space: nowrap;
    //line-height: 24px;
    //margin: 15px 5px 10px 10px;
    //cursor: pointer;
    ////overflow: hidden;
    //text-overflow: ellipsis;
  }
  .nav {
    //overflow-wrap: break-word;
    color: rgba(110, 110, 115, 1);
    //font-size: 14px;
    //font-family: SourceHanSansCN-Regular;
    //font-weight: normal;
    //white-space: nowrap;
    //line-height: 24px;
    //margin: 15px 5px 10px 10px;
    //cursor: pointer;
    ////overflow: hidden;
    //text-overflow: ellipsis;
  }

  //.nav:hover {
  //  overflow-wrap: break-word;
  //  color: #2D52D0;
  //  font-size: 14px;
  //  font-family: SourceHanSansCN-Regular;
  //  font-weight: normal;
  //  line-height: 24px;
  //  margin: 15px 10px 10px 10px;
  //  cursor: pointer;
  //  overflow: hidden;
  //  text-overflow: ellipsis;
  //  white-space: nowrap;
  //}

  .text_content{
    text-align: left;
    font-size: 15px;
  }
  .text_type{
    font-size: 14px;
    display: none;
  }
  .text_content_time{
    font-size: 12px;
  }
  .head_title{
    font-weight: bold;
  }
  /deep/.el-input {
    display: none;
  }
  /deep/.el-pagination span{
    min-width: 0;
  }
  /deep/.el-pagination__total {
    margin-right: 0;
  }

  .news-list {
    margin-bottom: 15px;
  }

  .news-item {
    display: flex;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eaeaea;
  }

  .news-image {
    flex: 0 0 100px;
    height: 80px;
    margin-right: 15px;
    overflow: hidden;
    border-radius: 4px;
    background-color: #f5f7fa;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .placeholder-image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #c0c4cc;

      i {
        font-size: 30px;
      }
    }
  }

  .news-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .news-title {
    text-align: left;
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;

    .text_type {
      display: inline-block;
      color: #3a8ee6;
      margin-right: 5px;
    }
  }

  .news-summary {
    text-align: left;
    margin: 0 0 8px;
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-footer {
    display: flex;
    justify-content: flex-start;
  }

  .news-time {
    font-size: 12px;
    color: #909399;
  }

  .no-data {
    padding: 20px 0;
    text-align: center;
    color: #CCCCCC;
    font-size: 14px;
  }
}

// Add these new styles for the advanced search area
.advanced-search {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;

  h3 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .search-input {
      flex: 1;
      min-width: 200px;
    }

    .date-picker {
      width: 160px;
    }

    .search-button {
      min-width: 100px;
    }
  }
}

// Media query for mobile devices
@media only screen and (max-width: 800px) {
  .advanced-search {
    .search-form {
      flex-direction: column;

      .search-input,
      .date-picker,
      .search-button {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/navigation.vue